import '../App.css';
import { useParams, useNavigate} from 'react-router-dom';
import { Component } from 'react';
import EnvironmentService from "../service/environmentService";
import ShowService from '../service/showService';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} Navigate={useNavigate()} />;
}


class ShowsSeasonOverview extends Component {
    // var movies = [];



  constructor(props){
    super(props);

    this.environmentService = new EnvironmentService();
    this.ShowService = new ShowService();

    console.log("HMMMMMM " +  props.uuid);
    this.state = {
        seasons : []
    }
  }

  componentDidMount(){
    console.log("This props " + this.props.params.uuid);

    this.getMovies();
  }

  async getMovies(){
    //http://localhost:5001/api/show/1a0d9def-3539-4e4b-8297-9390691a4e68/seasons/overview?token=2960de20-52b6-49b2-9d7d-40feb827e4de
    var result = await this.ShowService.GetShowSeasons(this.props.params.uuid)
   this.setState({
    seasons : result
   })

  }

  render(){
    const seasons = this.state.seasons;
    if(!seasons) return null;


    return(
       <div>
          <div>
            <text class="page-title">Seasons</text>
          </div>
          <div class="grid-container">
            {seasons.map((season) =>(
              <div class="grid-item" key={season.uuid}>
                <a href={this.environmentService.getFrontEndEnvironmentHost() + '/shows/season/' + season.uuid} className='link-hidden'>
                  <div>
                    <text> 
                        {season.name}<br/>
                    </text>
                  </div>
                </a>
              </div>
            ))
          }
          </div>
       </div> 
      )

  }




}

export default withParams(ShowsSeasonOverview);
